import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import { AssistantPage } from "./AssistantPage";
import { TeamPage } from "./TeamPage";
import { TeamPageProvider } from "./TeamPage/TeamPageContext";
import { MainLayout } from "layouts";
import styles from "./styles.module.scss";
import { CircularProgress } from "@mui/material";
import { RenderSidebar } from "./components/RenderSidebar";
import { useWorkspaceData } from "shared/hooks";

export const WorkspacePage: React.FC = () => {
	const navigate = useNavigate();
	const { workspace, loadingWorkspace, teams, loadingTeams } = useWorkspaceData();

	const handleSelectAssistant = useCallback(() => {
		navigate("/");
	}, [navigate]);

	const handleSelectTeam = useCallback(
		(id: string) => {
			navigate(`/team/${id}`);
		},
		[navigate],
	);

	const renderSidebar = (
		<RenderSidebar
			loadingTeams={loadingTeams}
			teams={teams}
			setSelectedTeamId={handleSelectTeam}
			onSelectAssistant={handleSelectAssistant}
		/>
	);

	if (loadingWorkspace) {
		return (
			<MainLayout sidebar={renderSidebar}>
				<div className={styles.loadingState}>
					<CircularProgress
						color="inherit"
						size={24}
					/>
					<span>Carregando workspace...</span>
				</div>
			</MainLayout>
		);
	}

	return (
		<MainLayout
			sidebar={renderSidebar}
			contentStyle={{ padding: 0, overflow: "hidden" }}
		>
			<div className={styles.container}>
				<Routes>
					<Route
						path="/"
						element={<AssistantPage workspace={workspace} />}
					/>
					<Route
						path="/team/:teamId/*"
						element={
							<TeamPageProvider
								workspace={workspace}
								teams={teams}
								loadingTeams={loadingTeams}
							>
								<TeamPage />
							</TeamPageProvider>
						}
					/>
				</Routes>
			</div>
		</MainLayout>
	);
};
